"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountGradePreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="account-grade-preview-page">
    <div class="row">
      <div class="col-lg-12 col-12 pb-lg-5">
        <div class="mb-2">
          <h1>${'accountGrade.previewTitle'.t()}</h1>
          <div class="text-zero top-right-button-container">
            <button @click="${x => x.editAccountGrade()}" type="button"
              class="top-right-button mr-2 btn btn-primary btn-lg" ?disabled="${x => !x.accountGrade}">
              ${'crud.edit'.t()}
            </button>
            <button @click="${x => x.goBack()}" type="button"
              class="top-right-button btn btn-primary btn-lg">
              ${'common.back'.t()}
            </button>
          </div>
        </div>

        ${(0, fast_element_1.when)(x => x.accountGrade, (0, fast_element_1.html) `        
          
          <div class="row mb-4">
            
            <div class="col-lg-8 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body">
                  <h5 class="card-title text-secondary mb-4">
                    <i class="iconsminds-crown-2 mr-2"></i>
                    ${'accountGrade.basicInfo'.t()}
                  </h5>
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-tag"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'accountGrade.name'.t()}</small>
                          <strong>${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.name) || '-'; }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-wallet"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'accountGrade.price'.t()}</small>
                          <strong class="price-display">${x => { var _a, _b; return ((_b = (_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.price) === null || _b === void 0 ? void 0 : _b.toFixed(2)) || '0.00'; }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-energy"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'accountGrade.creditsPerMonth'.t()}</small>
                          <strong>${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.creditsPerMonth) ? x.accountGrade.creditsPerMonth.toLocaleString() + ' credits' : 'None'; }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-check"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'common.active'.t()}</small>
                          <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.active) ? 'text-success' : 'text-danger'; }}">
                            ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.active) || false); }}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  
                  ${(0, fast_element_1.when)(x => { var _a; return (_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.description; }, (0, fast_element_1.html) `
                    <div class="row">
                      <div class="col-12 mb-3">
                        <div class="d-flex align-items-start">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-light text-muted">
                              <i class="simple-icon-info"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'accountGrade.description'.t()}</small>
                            <div class="mt-1">${x => { var _a; return (_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.description; }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  `)}
                </div>
              </div>
            </div>
            
            
            <div class="col-lg-4 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body">
                  <h5 class="card-title text-secondary mb-3">
                    <i class="simple-icon-speedometer mr-2"></i>
                    ${'accountGrade.limits'.t()}
                  </h5>
                  <div class="d-flex flex-column gap-3">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <i class="simple-icon-people mr-2 text-muted"></i>
                        <small class="text-muted">${'accountGrade.maxUsers'.t()}</small>
                      </div>
                      <span class="badge ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.maxUsers) === null ? 'badge-success' : 'badge-info'; }}">
                        ${x => { var _a; return x.formatLimitValue(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.maxUsers) || null); }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <i class="simple-icon-user mr-2 text-muted"></i>
                        <small class="text-muted">${'accountGrade.maxAvatars'.t()}</small>
                      </div>
                      <span class="badge ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.maxAvatars) === null ? 'badge-success' : 'badge-info'; }}">
                        ${x => { var _a; return x.formatLimitValue(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.maxAvatars) || null); }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <i class="simple-icon-folder mr-2 text-muted"></i>
                        <small class="text-muted">${'accountGrade.maxProjectsCount'.t()}</small>
                      </div>
                      <span class="badge ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.maxProjectsCount) === null ? 'badge-success' : 'badge-info'; }}">
                        ${x => { var _a; return x.formatLimitValue(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.maxProjectsCount) || null); }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <i class="simple-icon-notebook mr-2 text-muted"></i>
                        <small class="text-muted">${'accountGrade.maxKnowledgeEntries'.t()}</small>
                      </div>
                      <span class="badge ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.maxKnowledgeEntries) === null ? 'badge-success' : 'badge-info'; }}">
                        ${x => { var _a; return x.formatLimitValue(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.maxKnowledgeEntries) || null); }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <i class="simple-icon-settings mr-2 text-muted"></i>
                        <small class="text-muted">${'accountGrade.customAiModels'.t()}</small>
                      </div>
                      <span class="badge ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.customAiModels) === null ? 'badge-success' : 'badge-info'; }}">
                        ${x => { var _a; return x.formatLimitValue(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.customAiModels) || null); }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          
          <div class="row mb-4">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-body">
                  <h5 class="card-title text-secondary mb-4">
                    <i class="simple-icon-star mr-2"></i>
                    ${'accountGrade.features'.t()}
                  </h5>
                  <div class="feature-grid">
                    <div class="row g-3">
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.advancedPrompts) ? 'enabled' : 'disabled'; }}">
                            <i class="iconsminds-magic-wand"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.advancedPrompts'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.advancedPrompts) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.advancedPrompts) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.promptAssist) ? 'enabled' : 'disabled'; }}">
                            <i class="simple-icon-bulb"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.promptAssist'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.promptAssist) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.promptAssist) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.antiHallucination) ? 'enabled' : 'disabled'; }}">
                            <i class="simple-icon-shield"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.antiHallucination'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.antiHallucination) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.antiHallucination) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.advancedReports) ? 'enabled' : 'disabled'; }}">
                            <i class="simple-icon-chart"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.advancedReports'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.advancedReports) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.advancedReports) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.chatThreadSharing) ? 'enabled' : 'disabled'; }}">
                            <i class="simple-icon-share"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.chatThreadSharing'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.chatThreadSharing) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.chatThreadSharing) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.customBranding) ? 'enabled' : 'disabled'; }}">
                            <i class="iconsminds-brush"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.customBranding'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.customBranding) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.customBranding) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.widgets) ? 'enabled' : 'disabled'; }}">
                            <i class="simple-icon-grid"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.widgets'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.widgets) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.widgets) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.voiceAgent) ? 'enabled' : 'disabled'; }}">
                            <i class="simple-icon-microphone"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.voiceAgent'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.voiceAgent) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.voiceAgent) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="feature-item d-flex align-items-center">
                          <div class="feature-icon ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.writingStyles) ? 'enabled' : 'disabled'; }}">
                            <i class="simple-icon-pencil"></i>
                          </div>
                          <div>
                            <small class="d-block text-muted">${'accountGrade.writingStyles'.t()}</small>
                            <strong class="status-indicator ${x => { var _a; return ((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.writingStyles) ? 'text-success' : 'text-danger'; }}">
                              ${x => { var _a; return x.getBooleanText(((_a = x.accountGrade) === null || _a === void 0 ? void 0 : _a.writingStyles) || false); }}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `)}

        <div class="card text-center" ?hidden="${x => !x.loading}">
          <div class="card-body">
            <app-loader></app-loader>
            <p class="mt-3">${() => 'common.loading'.t()}</p>
          </div>
        </div>

        <div class="card text-center" ?hidden="${x => x.loading || x.accountGrade}">
          <div class="card-body">
            <p class="text-muted">${() => 'accountGrade.notFound'.t()}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

`;
require("./styles/layout.scss");
const styles = T.css `.account-grade-preview-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
.account-grade-preview-page .icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.account-grade-preview-page .card {
  border: none;
  border-radius: 12px;
  transition: all 0.3s ease;
}
.account-grade-preview-page .card.shadow-sm {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.account-grade-preview-page .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
.account-grade-preview-page .card .card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px 12px 0 0;
}
.account-grade-preview-page .card .card-header.bg-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
}
.account-grade-preview-page .badge {
  font-size: 0.85rem;
  padding: 0.5em 0.75em;
  border-radius: 20px;
  font-weight: 500;
}
.account-grade-preview-page .badge.badge-success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
}
.account-grade-preview-page .badge.badge-info {
  background: linear-gradient(135deg, #17a2b8 0%, #6f42c1 100%);
}
.account-grade-preview-page .badge.badge-warning {
  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
}
.account-grade-preview-page .badge.badge-danger {
  background: linear-gradient(135deg, #dc3545 0%, #e83e8c 100%);
}
.account-grade-preview-page .badge.badge-primary {
  background: linear-gradient(135deg, #007bff 0%, #6610f2 100%);
}
.account-grade-preview-page .status-indicator {
  font-weight: 600;
}
.account-grade-preview-page .status-indicator.text-success {
  color: #28a745 !important;
}
.account-grade-preview-page .status-indicator.text-danger {
  color: #dc3545 !important;
}
.account-grade-preview-page .price-display {
  font-size: 1.5rem;
  font-weight: 700;
  color: #28a745;
}
.account-grade-preview-page .feature-grid .feature-item {
  padding: 0.75rem;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}
.account-grade-preview-page .feature-grid .feature-item:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}
.account-grade-preview-page .feature-grid .feature-item .feature-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
}
.account-grade-preview-page .feature-grid .feature-item .feature-icon.enabled {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}
.account-grade-preview-page .feature-grid .feature-item .feature-icon.disabled {
  background: #e9ecef;
  color: #6c757d;
}`;
const shadowOptions = { "mode": "open" };
let AccountGradePreview = class AccountGradePreview extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.accountGradeId = null;
        this.loading = false;
        this.accountGrade = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        // Get account grade ID from route params
        const params = this.getRouteParams();
        if (params === null || params === void 0 ? void 0 : params.id) {
            this.accountGradeId = params.id;
            await this.loadAccountGrade();
        }
    }
    getRouteParams() {
        const path = window.location.pathname;
        const segments = path.split('/');
        const previewIndex = segments.indexOf('preview');
        if (previewIndex !== -1 && segments[previewIndex + 1]) {
            return { id: segments[previewIndex + 1] };
        }
        return null;
    }
    async loadAccountGrade() {
        if (!this.accountGradeId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('accountGrade.get', {
                routeParams: { id: this.accountGradeId }
            });
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                this.accountGrade = response.data;
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'accountGrade.loadError'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Load error:', error);
            this.notifyService.notify('accountGrade.loadError'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    editAccountGrade() {
        if (this.accountGradeId) {
            component_1.SiteMenu.goto.bind(this)(`/settings/account-grade/form/${this.accountGradeId}`);
        }
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/settings/account-grade/list');
    }
    formatLimitValue(value) {
        return value === null ? 'accountGrade.unlimited'.t() : value.toString();
    }
    getBooleanText(value) {
        return value ? 'common.yes'.t() : 'common.no'.t();
    }
    getBooleanClass(value) {
        return value ? 'text-success' : 'text-muted';
    }
};
exports.AccountGradePreview = AccountGradePreview;
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AccountGradePreview.prototype, "accountGradeId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AccountGradePreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IAccountGrade !== "undefined" && backendImport_1.IAccountGrade) === "function" ? _a : Object)
], AccountGradePreview.prototype, "accountGrade", void 0);
exports.AccountGradePreview = AccountGradePreview = __decorate([
    (0, client_1.RWSView)('account-grade-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], AccountGradePreview);
AccountGradePreview.defineComponent();
